import { MonthYearString } from 'types/MonthYearString';
import { Period } from 'types/Period';
import { NUMBER_OF_MONTH_BY_BATCH } from './ConditionedByClient';

export const findIndexOfMonthOfClosure = (yearMonths: MonthYearString[], lastClosureDate: Date) => {
  return yearMonths.findIndex((yearMonth: MonthYearString) => {
    const currentMonth = new Date(parseInt(yearMonth.year), parseInt(yearMonth.month), 0);

    lastClosureDate.setDate(0);

    return currentMonth === lastClosureDate;
  });
};

export const exceedsTheClosureDateIndex = (index: number, indexOfClosure: number) => {
  return index >= indexOfClosure;
};

export const getStartDateFromEndDate = (endDate: Date) => {
  return new Date(endDate.getFullYear(), endDate.getMonth() - NUMBER_OF_MONTH_BY_BATCH, 2);
};

export const getEndDateFromStartDate = (startDate: Date) => {
  return new Date(startDate.getFullYear(), startDate.getMonth() + NUMBER_OF_MONTH_BY_BATCH, 1);
};

export const getValidEndDate = (endDate: Date, latestModificationOfStock: Date | null) => {
  return new Date(Math.min(endDate.getTime(), latestModificationOfStock?.getTime() ?? 0));
};

export const getValideStartDate = (startDate: Date, sortingCenterInitializationDate: Date) => {
  return sortingCenterInitializationDate < startDate ? startDate : sortingCenterInitializationDate;
};

export const getDateFilterForScroll = (
  currentPeriod: Period | null,
  latestModificationOfStock: Date | null,
  sortingCenterInitializationDate: Date,
): Period => {
  let startDate = null;
  let endDate = null;

  const periodStartDate = currentPeriod?.startDate
    ? new Date(currentPeriod.startDate.getFullYear(), currentPeriod.startDate.getMonth(), 2)
    : null;

  const periodEndDate = currentPeriod?.endDate
    ? new Date(currentPeriod.endDate.getFullYear(), currentPeriod.endDate.getMonth(), 2)
    : null;

  if (periodStartDate && periodEndDate) {
    endDate = getValidEndDate(periodEndDate, latestModificationOfStock);
    endDate.setDate(2);
    startDate = getValideStartDate(periodStartDate, sortingCenterInitializationDate);
  } else if (periodStartDate && !periodEndDate) {
    endDate = getValidEndDate(getEndDateFromStartDate(periodStartDate), latestModificationOfStock);
    startDate = getValideStartDate(periodStartDate, sortingCenterInitializationDate);
  } else if (!periodStartDate && periodEndDate) {
    endDate = getValidEndDate(periodEndDate, latestModificationOfStock);
    startDate = getValideStartDate(getStartDateFromEndDate(endDate), sortingCenterInitializationDate);
  } else {
    if (latestModificationOfStock) {
      endDate = latestModificationOfStock;
      startDate = getValideStartDate(getStartDateFromEndDate(endDate), sortingCenterInitializationDate);
    } else {
      startDate = sortingCenterInitializationDate;
      endDate = getEndDateFromStartDate(startDate);
    }
  }

  return {
    startDate,
    endDate,
  };
};
